import React from 'react'
import styles from './loader-button.module.css'
import { FaSyncAlt } from 'react-icons/fa'

const LoaderButton = props => {
  const { isLoading, ...rest } = props;
  return (
    <button
      className={props.className}
      disabled={props.disabled || isLoading}
      {...rest}
    >
      {isLoading && <FaSyncAlt className={styles.spinning} />}
      {props.children}
    </button>
  );
}

export default LoaderButton;